import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiClient from '../../BaseUrl/ApiClient';
import { formatTimeDisplay } from './timeUtils';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';

function DetailHappyHour() {
  const { dealId } = useParams();
  const history = useHistory();
  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (!dealId) return;

    const fetchDealDetail = async () => {
      setLoading(true);
      try {
        const response = await ApiClient().get(`/admin/deal/happyHours/${dealId}`);
        const dealData = response.data?.responseData?.deal;

        if (!dealData) {
          toast.error('Deal not found');
          return;
        }

        setDeal(dealData);
      } catch (err) {
        toast.error(err.response?.data?.responseMessage?.[0] || 'Failed to fetch deal details');
      } finally {
        setLoading(false);
      }
    };

    fetchDealDetail();
  }, [dealId]);

  if (loading) return <div className="text-center mt-5">Loading...</div>;
  if (!deal) return <div className="text-center mt-5">No deal found</div>;

  const openModal = (index = 0) => {
    setCurrentImageIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % deal.dealPhoto.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + deal.dealPhoto.length) % deal.dealPhoto.length);
  };

  
  return (
    <div className="page-content">
      <ToastContainer />
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader className="d-flex align-items-center">
                <Button color="primary" onClick={() => history.goBack()}>
                  <i className="mdi mdi-arrow-left" />
                </Button>
                <h4 className="mb-0 ms-2">Happy Hour Deal Detail</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  {/* Photo with +N overlay */}
                  <Col md={4} className="mb-3">
                    {deal.dealPhoto?.length > 0 ? (
                      <div
                        style={{ position: 'relative', cursor: 'pointer' }}
                        onClick={() => openModal(0)}
                      >
                        <img
                          src={deal.dealPhoto[0].url}
                          alt="deal"
                          className="img-fluid rounded border"
                          style={{ width: '100%', maxHeight: '200px', objectFit: 'cover' }}
                        />
                        {deal.dealPhoto.length > 1 && (
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.4)',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '2rem',
                            fontWeight: 'bold',
                            borderRadius: '0.25rem'
                          }}>
                            +{deal.dealPhoto.length - 1}
                          </div>
                        )}
                      </div>
                    ) : (
                      <span>No Photo</span>
                    )}
                  </Col>

                  {/* Details */}
                  <Col md={8}>
                    <p><strong>Description:</strong> {deal.description || '-'}</p>
                    <p><strong>Category:</strong> {deal.category?.name || '-'}</p>
                    <p><strong>Days:</strong> {Array.isArray(deal.days) ? deal.days.join(', ') : '-'}</p>
                    <p>
                      <strong>Start Time:</strong> {formatTimeDisplay(deal.timeRange?.startTime, deal.timezone)}
                    </p>
                    <p>
                      <strong>End Time:</strong> {formatTimeDisplay(deal.timeRange?.endTime, deal.timezone)}
                    </p>
                    <p>
                      <strong>Status:</strong>{' '}
                      <span
                        className={`badge ${deal.isActive ? 'bg-success' : 'bg-danger'}`}
                        style={{ padding: '0.4em 0.8em', borderRadius: '50px' }}
                      >
                        {deal.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal for multiple images */}
        <Modal isOpen={modalOpen} toggle={closeModal} size="lg" centered>
          <ModalHeader toggle={closeModal}>
            Deal Photos ({currentImageIndex + 1} / {deal.dealPhoto?.length})
          </ModalHeader>
          <ModalBody className="text-center">
            {deal.dealPhoto?.length > 0 && (
              <>
                <img
                  src={deal.dealPhoto[currentImageIndex].url}
                  alt={`deal-${currentImageIndex}`}
                  style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
                />
                {deal.dealPhoto.length > 1 && (
                  <div className="d-flex justify-content-between mt-2">
                    <Button color="secondary" onClick={prevImage}>&larr; Prev</Button>
                    <Button color="secondary" onClick={nextImage}>Next &rarr;</Button>
                  </div>
                )}
              </>
            )}
          </ModalBody>
        </Modal>

      </Container>
    </div>
  );
}

export default DetailHappyHour;
